import type { Metric } from "web-vitals";
import { onCLS, onFCP, onINP, onLCP, onTTFB } from "web-vitals";

import { logger } from "@/lib/logger";

export type WebVitalsReporter = (metric: Metric) => void;

export function reportWebVitals(report: WebVitalsReporter = defaultReport): void {
  if (typeof window === "undefined") return;
  onCLS(report);
  onFCP(report);
  onINP(report);
  onLCP(report);
  onTTFB(report);
}

function defaultReport(metric: Metric): void {
  logger.info("web-vitals", {
    id: metric.id,
    name: metric.name,
    rating: metric.rating,
    value: Math.round(metric.value * 1000) / 1000,
  });
}
